/**
 * Action Types
 */
export const ACTION_TYPES = {
  SET_GEL_PREDICTION: "SET_GEL_PREDICTION",
  SET_GEL_PREDICTION_BAND_TOGGLE: "SET_GEL_PREDICTION_BAND_TOGGLE",
};

/**
 * Action: Set Gel Prediction
 * @param {object} gelPrediction - The gel prediction data
 * @returns {object} - The action object
 */
export const setGelPrediction = (gelPrediction) => ({
  type: ACTION_TYPES.SET_GEL_PREDICTION,
  payload: gelPrediction,
});

/**
 * Action: Set Gel Prediction Band Toggle
 * @param {boolean} toggleValue - The toggle value
 * @returns {object} - The action object
 */
export const setGelPredictionBandToggle = (toggleValue) => ({
  type: ACTION_TYPES.SET_GEL_PREDICTION_BAND_TOGGLE,
  payload: toggleValue,
});
